import { style } from '@vanilla-extract/css'

export const card = style({
  width: '100%',
  backgroundColor: '#FFFFFF',
  borderRadius: '16px',
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',
  boxShadow: '0px 8px 16px 0px #C5C5C50D',
})

export const heading = style({
  fontSize: '15px',
  fontWeight: '700',
  lineHeight: '1.5',
})

export const recommended = style({
  color: '#828282',
  fontSize: '12px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
})

export const note = style({
  color: '#828282',
  fontSize: '13px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
})
